import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import type { GuidanceState } from '~/utils/guidanceTypes'
import { STATE_CLASSES } from '~/utils/guidanceTypes'
import { parseGuidanceTags } from '~/utils/guidanceTagParser'


export default /*#__PURE__*/_defineComponent({
  __name: 'GuidanceBanner',
  props: {
    state: { default: 'safe' },
    message: { default: '' },
    expletive: { default: '' },
    dismissable: { type: Boolean, default: false },
    replacements: { default: () => ({}) }
  },
  emits: ["dismiss"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dismiss'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { state: GuidanceState, message: string, expletive: string, dismissable: boolean, replacements: Record<string, string> }





const visible = ref(true)

// Reset visibility when message content changes
watch(() => props.message, () => {
  visible.value = true
})

const stateClasses = computed(() => {
  const s = STATE_CLASSES[props.state] || STATE_CLASSES.safe
  return `${s.bg} ${s.text} ${s.border}`
})

const parsedMessage = computed(() =>
  parseGuidanceTags(props.message, props.replacements)
)

const parsedExpletive = computed(() =>
  parseGuidanceTags(props.expletive, props.replacements)
)

function dismiss() {
  visible.value = false
  emit('dismiss')
}

return { __sfc: true,props, emit, visible, stateClasses, parsedMessage, parsedExpletive, dismiss }
}

})